import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen, ChevronDown } from 'lucide-react';
const tomos = [{
  title: 'Tomo 1: Bases y Cortes',
  items: ['Qué hace realmente buena a una milanesa', 'Errores comunes que arruinan el resultado', 'Tipos de milanesa (tradicional vs moderna)', 'Carne vs pollo vs cerdo: diferencias clave', '🥩 Cortes de carne (CLAVE)', 'Comparativa visual entre cortes', 'Cómo cortar la carne correctamente', 'Espesor ideal según cocción', 'Preparación previa (golpeado, limpieza)', 'Checklist de base perfecta']
}, {
  title: 'Tomo 2: El Empanado',
  items: ['La lógica del empanado perfecto', 'Preparación correcta del huevo', 'Pan rallado vs panko', 'Condimentos clave', 'Cómo lograr adherencia perfecta', 'Empanado clásico paso a paso', 'Empanado doble crocante', 'Empanados saborizados', 'Texturas: crocante vs suave', 'Errores comunes', 'Conservación de milanesas crudas', 'Freezer inteligente y Producción en volumen', 'Checklist de empanado']
}, {
  title: 'Tomo 3: La Cocción',
  items: ['Fritura ideal (temperatura + técnica)', 'Tipos de aceite', 'Cómo evitar exceso de grasa', 'Punto perfecto de cocción', 'Técnica profesional de fritura', 'Milanesas al horno', 'Airfryer optimizado', 'Comparación de métodos', 'Cómo recalentar sin arruinar', 'Crocancia máxima', 'Problemas comunes y Ajustes según carne', 'Control de textura', 'Checklist de cocción']
}, {
  title: 'Tomo 4: Recetas y Práctica',
  items: ['Milanesa clásica perfecta', 'Milanesa de pollo jugosa', 'Milanesa de cerdo equilibrada', 'Versiones rápidas (menos de 20 min)', 'Milanesas para freezer', 'Sándwich de milanesa', 'Guarniciones rápidas', 'Versiones económicas', 'Cómo mejorar lo simple', 'Recetas rápidas variadas', 'Organización semanal', 'Cocinar en volumen y Rotación de comidas', 'Checklist diario']
}, {
  title: 'Tomo 5: Versiones Gourmet',
  items: ['Milanesa napolitana perfecta', 'Milanesa rellena', 'Milanesa a la suiza', 'Versiones con quesos especiales', 'Salsas clave', 'Empanados gourmet', 'Combinaciones creativas', 'Estilos internacionales', 'Presentación tipo restaurante', 'Emplatado simple', 'Crear tus propias recetas', 'Balance de sabores y Errores al innovar', 'Checklist gourmet']
}, {
  title: 'Tomo 6: El Sistema Completo',
  items: ['Cómo crear combinaciones propias', 'Bases + toppings + salsas', 'Sistema modular de recetas', 'Matriz de combinaciones', 'Adaptación según ocasión', 'Menús completos', 'Eventos y reuniones', 'Versiones saludables', 'Versiones indulgentes', 'Optimización de costos', 'Organización en cocina', 'Plan semanal completo', 'Evolución del cocinero', 'Checklist final']
}];
export function Tomos() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-crema text-bordo py-20 px-4 md:px-8" data-id="element-131">
      <div className="max-w-4xl mx-auto" data-id="element-132">
        <div className="text-center mb-16" data-id="element-133">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-134">
            ¿Qué incluye La Biblia de la Milanesa?
          </h2>
          <p className="text-xl text-gray-700" data-id="element-135">
            Incluye un sistema completo dividido en tomos prácticos.
          </p>
        </div>

        <div className="space-y-4" data-id="element-136">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="bg-white rounded-2xl shadow-lg border border-bordo/10 overflow-hidden" data-id="element-137">
              <button onClick={() => toggle(index)} className="w-full flex items-center justify-between gap-4 p-6 text-left hover:bg-crema-dark transition-colors" data-id="element-138">
                <div className="flex items-center gap-3" data-id="element-139">
                  <BookOpen className="text-bordo shrink-0" size={28} data-id="element-140" />
                  <h3 className="font-serif font-bold text-xl" data-id="element-141">{tomo.title}</h3>
                </div>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-142">
                  <ChevronDown className="text-bordo shrink-0" size={24} data-id="element-143" />
                </motion.div>
              </button>

              <AnimatePresence initial={false} data-id="element-144">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-145">
                    <ul className="space-y-2 px-6 pb-6 pt-2 border-t border-bordo/10" data-id="element-146">
                      {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-147">
                          <span className="text-bordo mt-1" data-id="element-148">•</span>
                          <span data-id="element-149">{item}</span>
                        </li>)}
                    </ul>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}